export default __webpack_public_path__ + "static/media/pencil-red.287fa843.svg";